"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactInfoType = void 0;
const mobx_1 = require("mobx");
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
const ValidationUtils_1 = require("../util/ValidationUtils");
const validator_1 = __importDefault(require("validator"));
var ContactInfoType;
(function (ContactInfoType) {
    ContactInfoType["EMAIL"] = "EMAIL";
    ContactInfoType["PHONE"] = "PHONE";
    ContactInfoType["ADDRESS"] = "ADDRESS";
})(ContactInfoType || (exports.ContactInfoType = ContactInfoType = {}));
const GET_CONTACT_ADDRESSES_REL = '/contact-address/get';
const PUT_CONTACT_ADDRESSES_REL = '/contact-address/put';
const POST_CONTACT_ADDRESSES_REL = '/contact-address/post';
const GET_CONTACT_INFO_REL = '/contact-info/get';
const GET_CONTACT_INFO_REPRESENTATIVE = '/contact-info/representative';
const PUT_CONTACT_INFO_REL = '/contact-info/put';
const POST_CONTACT_INFO_REL = 'contact-info/post';
class ContactInfoStore {
    constructor(rootStore) {
        Object.defineProperty(this, "phoneCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '+372'
        });
        Object.defineProperty(this, "phoneInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.initContactInfo(ContactInfoType.PHONE)
        });
        Object.defineProperty(this, "emailInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.initContactInfo(ContactInfoType.EMAIL)
        });
        Object.defineProperty(this, "contactAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.initContactAddress()
        });
        Object.defineProperty(this, "isCustomerConsentReady", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "formIsErrorneous", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isFormLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isContactAddressInitialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "init", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.loadContactInfosForConsent();
            }
        });
        Object.defineProperty(this, "reset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.isFormLoading = false;
                this.phoneInfo = this.initContactInfo(ContactInfoType.PHONE);
                this.emailInfo = this.initContactInfo(ContactInfoType.EMAIL);
                this.contactAddress = this.initContactAddress();
                this.isCustomerConsentReady = true;
                this.formIsErrorneous = false;
                this.isContactAddressInitialized = false;
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.ssoStore = rootStore.ssoStore;
        this.rootStore = rootStore;
        (0, mobx_1.reaction)(() => this.ssoStore.initStores, this.init);
    }
    get isEmailValidOrEmpty() {
        const isValid = validator_1.default.isEmail(this.emailInfo.value);
        return isValid || this.isEmailEmpty;
    }
    get isEmailEmpty() {
        return validator_1.default.isEmpty(this.emailInfo.value);
    }
    get isPhoneValidOrEmpty() {
        const isPhone = ValidationUtils_1.PHONE_REGEXP.test(this.phoneInfo.value);
        return isPhone || this.isPhoneBlank;
    }
    get isPhoneBlank() {
        return validator_1.default.isEmpty(this.phoneInfo.value);
    }
    get isFormValid() {
        const ciValid = this.isEmailValidOrEmpty && this.isPhoneValidOrEmpty;
        const bothCIEmpty = this.isPhoneBlank && this.isEmailEmpty;
        const addressValid = this.rootStore.contactAddressStore.isAddressFormValid;
        const b2cValid = ciValid && !bothCIEmpty;
        return (this.isB2c ? b2cValid : ciValid) && addressValid && !this.isFormLoading;
    }
    get isB2c() {
        return this.ssoStore.isPrivateCustomer;
    }
    initContactInfo(type) {
        return {
            id: null,
            isNew: true,
            prime: true,
            isDirty: false,
            value: '',
            linksJwt: null,
            type
        };
    }
    initContactAddress() {
        return {
            id: null,
            isNew: true,
            prime: true,
            isDirty: false,
            address: {
                room: null,
                city: null,
                region: null,
                street: null,
                building: null,
                postalCode: null,
                municipality: null,
                roomRegistryId: null,
                addressRegistryId: null,
                buildingRegistryId: null
            },
            linksJwt: null
        };
    }
    async saveContactInfo(contactInfo) {
        const { isNew, isDirty, prime } = contactInfo;
        if (!contactInfo.value) {
            return Promise.resolve();
        }
        if (isNew) {
            return ApiUtil_1.default.post(POST_CONTACT_INFO_REL, contactInfo);
        }
        const updateData = {
            value: isDirty ? contactInfo.value : null,
            linksJwt: contactInfo.linksJwt,
            prime
        };
        return !prime || isDirty ? ApiUtil_1.default.put(PUT_CONTACT_INFO_REL, updateData) : null;
    }
    async saveAddress(contactAddress) {
        const { isNew, isDirty, prime } = contactAddress;
        if (isNew) {
            return ApiUtil_1.default.post(POST_CONTACT_ADDRESSES_REL, this.contactAddress);
        }
        return !prime || isDirty ? ApiUtil_1.default.put(PUT_CONTACT_ADDRESSES_REL, this.contactAddress) : null;
    }
    async saveCustomerInfo() {
        this.isFormLoading = true;
        try {
            await Promise.all([this.saveContactInfo(this.phoneInfo), this.saveContactInfo(this.emailInfo), this.saveAddress(this.contactAddress)]);
            this.reset();
        }
        catch (e) {
            this.formIsErrorneous = true;
            this.isFormLoading = false;
        }
    }
    getContactInfo(hasPrime, infos) {
        if (!infos.length) {
            return null;
        }
        const maxId = Math.max.apply(Math, infos.map((e) => e.id));
        return hasPrime ? infos.find((p) => p.prime) : infos.find((p) => p.id === maxId);
    }
    getInfoByType(type) {
        return type === ContactInfoType.PHONE ? this.phoneInfo : this.emailInfo;
    }
    initializeContactInfoValues(hasPrime, infos, type) {
        const info = this.getContactInfo(hasPrime, infos);
        const entry = this.getInfoByType(type);
        entry.isNew = !info;
        if (info) {
            entry.value = info.value;
            entry.prime = info.prime;
            entry.linksJwt = info.linksJwt;
        }
    }
    initializeContactAddressValues(hasPrime, addressses) {
        const resource = this.getContactInfo(hasPrime, addressses);
        const entry = resource ? (this.contactAddress = resource) : this.contactAddress;
        entry.isNew = !resource;
        this.isContactAddressInitialized = true;
    }
    changeEmailInfo(value) {
        this.emailInfo.value = value;
        this.emailInfo.isDirty = true;
    }
    changePhoneInfo(value) {
        this.phoneInfo.value = value;
        this.phoneInfo.isDirty = true;
    }
    setRoomId(value) {
        this.contactAddress.address.roomRegistryId = value;
    }
    setBuildingId(value) {
        this.contactAddress.address.buildingRegistryId = value;
    }
    setRegistryId(value) {
        this.contactAddress.address.addressRegistryId = value;
    }
    setAddressIsDirty() {
        this.contactAddress.isDirty = true;
    }
    resetOldAddressReferences() {
        this.contactAddress.address.roomRegistryId = null;
        this.contactAddress.address.buildingRegistryId = null;
        this.contactAddress.address.addressRegistryId = null;
    }
    async loadContactInfosForConsent() {
        try {
            const contactInfos = (await ApiUtil_1.default.get(GET_CONTACT_INFO_REL)).data.contactInfos;
            const contactAddresses = await ApiUtil_1.default.get(GET_CONTACT_ADDRESSES_REL);
            const emailInfos = contactInfos.filter((i) => i.type === ContactInfoType.EMAIL && i.prime === true);
            const phoneInfos = contactInfos.filter((i) => i.type === ContactInfoType.PHONE && i.prime === true);
            const hasPrimePhone = phoneInfos.some((x) => x.prime);
            const hasPrimeEmail = emailInfos.some((x) => x.prime);
            const hasPrimeAddress = (contactAddresses.data.addresses || []).some((x) => x.prime);
            this.isCustomerConsentReady = this.isB2c ? (hasPrimeEmail || hasPrimePhone) && hasPrimeAddress : hasPrimeAddress;
            if (!this.isCustomerConsentReady) {
                this.initializeContactInfoValues(hasPrimeEmail, emailInfos, ContactInfoType.EMAIL);
                this.initializeContactInfoValues(hasPrimePhone, phoneInfos, ContactInfoType.PHONE);
                this.initializeContactAddressValues(hasPrimeAddress, contactAddresses.data.addresses);
            }
        }
        catch (e) {
            this.formIsErrorneous = true;
        }
        finally {
            this.isFormLoading = false;
        }
    }
    async loadRepresentativeContactInfos() {
        const contactInfos = (await ApiUtil_1.default.get(GET_CONTACT_INFO_REPRESENTATIVE)).data.contactInfos;
        (0, mobx_1.runInAction)(() => {
            this.emailInfo = contactInfos.find((contactInfo) => contactInfo.prime && contactInfo.type === ContactInfoType.EMAIL);
            this.phoneInfo = contactInfos.find((contactInfo) => contactInfo.prime && contactInfo.type === ContactInfoType.PHONE);
        });
    }
}
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "phoneCode", void 0);
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "phoneInfo", void 0);
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "emailInfo", void 0);
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "contactAddress", void 0);
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "isCustomerConsentReady", void 0);
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "formIsErrorneous", void 0);
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "isFormLoading", void 0);
__decorate([
    mobx_1.observable
], ContactInfoStore.prototype, "isContactAddressInitialized", void 0);
__decorate([
    mobx_1.computed
], ContactInfoStore.prototype, "isEmailValidOrEmpty", null);
__decorate([
    mobx_1.computed
], ContactInfoStore.prototype, "isEmailEmpty", null);
__decorate([
    mobx_1.computed
], ContactInfoStore.prototype, "isPhoneValidOrEmpty", null);
__decorate([
    mobx_1.computed
], ContactInfoStore.prototype, "isPhoneBlank", null);
__decorate([
    mobx_1.computed
], ContactInfoStore.prototype, "isFormValid", null);
__decorate([
    mobx_1.computed
], ContactInfoStore.prototype, "isB2c", null);
__decorate([
    mobx_1.action
], ContactInfoStore.prototype, "saveCustomerInfo", null);
exports.default = ContactInfoStore;
